import React, { Component } from 'react';

import Fallback from './blocks/Fallback';

export default class ErrorBoundary extends Component {
  state = {};

  componentDidMount() {
    if (Error && Error.stackTraceLimit) {
      Error.stackTraceLimit = 30;
    }
  }

  componentDidCatch(error) {
    this.setState({ error });

    window.scrollTo(0, 0);

    // eslint-disable-next-line no-param-reassign
    error.message = `ErrorBoundary: ${error.message}`;

    if (global.trackJs) {
      global.trackJs.track(error);
    }
  }

  render() {
    const { error } = this.state;

    if (error) {
      return <Fallback />;
    }

    return this.props.children;
  }
}
